export default __webpack_public_path__ + "static/media/wifi.inline.97017f36.svg";